module.exports = __webpack_public_path__ + "static/media/03.63411a62.png";